import React from 'react';
import img from './error_image.jpg';
import './error.css';

const Error = ()=>{
    return(
        <div className="error-block">
            <img src={img} alt="Ошибка"/>
            <p className="error-block-text">We apologize for the inconvenience.</p>
        </div>
    );
}

export default Error;